<template>
<v-app class="grey lighten-3">
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-container grid-list-md>
        <v-card>
          <v-card-title class="project">
            <div><span class="headline">Make a Payment</span></div>
          </v-card-title>
          <v-card-text>
            <v-layout row>
            <v-flex xs6>
                <v-subheader class="black--text title">Project ID:</v-subheader>
            </v-flex>
            <v-flex xs6>
                <v-subheader class="black--text headline">
                    {{indexData.datas.id}}
                </v-subheader>
            </v-flex>
            </v-layout>
            <v-layout row>
            <v-flex xs6>
                <v-subheader class="black--text title">Total Budget:</v-subheader>
            </v-flex>
            <v-flex xs6>
                <v-subheader class="black--text headline">
                    {{indexData.datas.total_budget_amount}} Tk
                </v-subheader>
            </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs6>
                    <v-subheader class="black--text title">Paid Amount:</v-subheader>
                </v-flex>
                <v-flex xs6>
                    <v-subheader class="black--text headline">
                        {{indexData.datas.paid_amount}} Tk
                    </v-subheader>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs6>
                    <v-subheader class="black--text title">Remainig Payment:</v-subheader>
                </v-flex>
                <v-flex xs6>
                    <v-subheader class="black--text headline">
                        {{indexData.datas.total_budget_amount-indexData.datas.paid_amount}} Tk
                    </v-subheader>
                </v-flex>
            </v-layout>

          </v-card-text>

          <v-card-actions>
            <v-btn 
            class="button text-none" 
            flat 
            @click="back" 
            >
            Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn class="button text-none" flat @click="payNow">Pay Now</v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-flex>  
  </v-layout>
</v-app>
</template>

<script>
import {mapGetters} from 'vuex'
import router from '../../../router';

 export default {
   
    data: () => ({
      apiUrl: 'client-pay',
      editedIndex: -1,
      project_status_id:'',
      payment_status_id:'',
      project_id:'',
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg']),   
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        let id = localStorage.getItem('projectId');
        this.project_id =id;
        this.$store.dispatch('remainingPaymentPage', ['payment',id])
        this.project_status_id = this.indexData.datas.project_status_id
        this.payment_status_id = this.indexData.datas.payment_status_id
      },

      payNow() {
        router.push('/remaining-payment-method')
      },

      back(){
        if (this.project_id !=null && this.project_id !=undefined) {
          this.$store.dispatch('getProjectDetails',[ this.project_id, 'client-view'])
        }else{
          alert('Project id not found!')
        }
      }
    }
  }
</script>

<style scoped>
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color:white;
}
.headline{
    color: white;
}
.project{ 
  background: #ff2e2e;  
}

</style>
